import { isStr } from "./utils";

describe("isStr", () => {
    it("returns true for strings", () => {
        expect(isStr("")).toBeTruthy();
        expect(isStr("test")).toBeTruthy();
    });

    it("returns false for non-String values", () => {
        expect(isStr(undefined)).toBeFalsy();
        expect(isStr(1)).toBeFalsy();
        expect(isStr(NaN)).toBeFalsy();
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        expect(isStr(() => {})).toBeFalsy();
        expect(isStr(null)).toBeFalsy();
        expect(isStr({})).toBeFalsy();
    });
});
